import { TodosLayout } from "@/components/layouts/todos-layout";
import { useRoutePersistence } from "@/hooks/use-route-persistance";
import { useTenant } from "@/providers/session";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang",
)({
  component: PayableLayout,
});

function PayableLayout() {
  const { companySlug } = useTenant();

  useRoutePersistence(companySlug, "payable");

  return (
    <TodosLayout type="payable">
      <Outlet />
    </TodosLayout>
  );
}
